import { useMemo } from "react";

import { ExpandContent } from "@bridgesplit/ui";
import { useLoopscaleWalletContext, usePrivyWalletConnect } from "@bridgesplit/abf-react";
import { useWallets } from "@privy-io/react-auth/solana";
import { AppTracking, TrackEvent } from "app/types";

import { WalletDisplaySmall, WalletButton } from "./index";

export function WalletNotConnected() {
    const {
        data: { userWalletAddress: activeWallet }
    } = useLoopscaleWalletContext();
    const { connectWallet } = usePrivyWalletConnect();
    const { ready } = useWallets();

    const header = useMemo(() => {
        if (!activeWallet) return "";

        if (activeWallet.length > 1) return "Please connect one of your self-custodial wallets";

        return "Please connect your self-custodial wallet";
    }, [activeWallet]);

    return (
        <>
            <ExpandContent
                hideExpand={!activeWallet}
                defaultExpanded
                textVariant="body2"
                textColor="caption"
                spacing={0.5}
                header={header}
            >
                <WalletDisplaySmall key={activeWallet} address={activeWallet} />
            </ExpandContent>
            <WalletButton
                trackingEvent={AppTracking.from(TrackEvent.SubmitWalletConnect)}
                onClick={() => connectWallet()}
                disabled={!ready}
            />
        </>
    );
}
